import jsCookie from 'js-cookie';
import { Reducer } from 'react';

import { InitialStateType } from '@/modules/periodicJobs/context/context';
import { IGeneral } from '@/shared/types';

export enum periodicJobsActionsTypes {
  setStartDate = 'SET_START_DATE',
  setEndDate = 'SET_END_DATE',
  addPlot = 'ADD_PLOT',
  removePlot = 'REMOVE_PLOT',
  setPlots = 'SET_PLOTS',
  setCrop = 'SET_CROP',
  setPageNumber = 'SET_PAGENUMBER',
}

type periodicJobsPayload = {
  [periodicJobsActionsTypes.setStartDate]: InitialStateType['startDate'];
  [periodicJobsActionsTypes.setEndDate]: InitialStateType['endDate'];
  [periodicJobsActionsTypes.setCrop]: InitialStateType['selectedCrop'];
  [periodicJobsActionsTypes.setPlots]: InitialStateType['selectedPlots'];
  [periodicJobsActionsTypes.addPlot]: InitialStateType['selectedPlots'][0];
  [periodicJobsActionsTypes.removePlot]: InitialStateType['selectedPlots'][0];
  [periodicJobsActionsTypes.setPageNumber]: InitialStateType['tablePageNumber'];
};

export type Actions =
  IGeneral.ActionMap<periodicJobsPayload>[keyof IGeneral.ActionMap<periodicJobsPayload>];

export const periodicJobsReducer: Reducer<InitialStateType, Actions> = (
  state: InitialStateType,
  action: Actions
) => {
  switch (action.type) {
    case periodicJobsActionsTypes.setStartDate:
      return {
        ...state,
        startDate: action.payload,
      };
    case periodicJobsActionsTypes.setEndDate:
      return {
        ...state,
        endDate: action.payload,
      };
    case periodicJobsActionsTypes.setCrop:
      jsCookie.set('periodicJobsCrop', JSON.stringify(action.payload));
      return {
        ...state,
        tablePageNumber: 1,
        selectedCrop: action.payload,
      };
    case periodicJobsActionsTypes.setPlots:
      return {
        ...state,
        selectedPlots: action.payload,
      };
    case periodicJobsActionsTypes.addPlot:
      return {
        ...state,
        selectedPlots: [...state.selectedPlots, action.payload],
      };
    case periodicJobsActionsTypes.removePlot:
      return {
        ...state,
        selectedPlots: state.selectedPlots.filter(
          (plot) => plot.id !== action.payload.id
        ),
      };
    case periodicJobsActionsTypes.setPageNumber:
      return {
        ...state,
        tablePageNumber: action.payload,
      };
    default:
      return state;
  }
};
